const KEYCLOAK_SESSION_FRESHNESS = 'keycloak-session-freshness';
const KEYCLOAK_SESSION_STATE = 'keycloak-session-state';

type KeycloakSessionFreshness = 'fresh' | 'stale';

export function getState() {
  return window.sessionStorage.getItem(KEYCLOAK_SESSION_STATE);
}

export function setState(state: string) {
  window.sessionStorage.setItem(KEYCLOAK_SESSION_STATE, state);
}

export function getFreshness() {
  return window.sessionStorage.getItem(KEYCLOAK_SESSION_FRESHNESS);
}

export function setFreshness(freshness: KeycloakSessionFreshness) {
  window.sessionStorage.setItem(KEYCLOAK_SESSION_FRESHNESS, freshness);
}
